import type { RouteRecordRaw } from "vue-router";
import { RouteName } from "@/apps/person-registration/router/RouteName";
import { personRegistrationTranslationGuard } from "@/router/translationGuards";

// Lazy-loaded view components for code splitting
const CorrectionView = () =>
	import("@/apps/person-registration/views/CorrectionView.vue");
const ExternalUploaderView = () =>
	import("@/apps/person-registration/views/ExternalUploaderView.vue");
const IdentificationUploaderView = () =>
	import("@/apps/person-registration/views/IdentificationUploaderView.vue");
const IdRejectedView = () =>
	import("@/apps/person-registration/views/IdRejectedView.vue");
const PasswordCreationView = () =>
	import("@/apps/person-registration/views/PasswordCreationView.vue");
const PaymentMethodView = () =>
	import("@/apps/person-registration/views/PaymentMethodsView.vue");
const PersonContactInfoView = () =>
	import("@/apps/person-registration/views/PersonContactInfoView.vue");
const PersonRegistrationView = () =>
	import("@/apps/person-registration/views/PersonRegistrationView.vue");
const PrivacyPolicyView = () =>
	import("@/apps/person-registration/views/PrivacyPolicyView.vue");
const RejectionView = () =>
	import("@/apps/person-registration/views/RejectionView.vue");
const RegistrationCompleteView = () =>
	import("@/apps/person-registration/views/RegistrationCompleteView.vue");
const RegistrationExpiredView = () =>
	import("@/apps/person-registration/views/RegistrationExpiredView.vue");
const StepwiseContactInfoView = () =>
	import("@/apps/person-registration/views/StepwiseContactInfoView.vue");
const StyleView = () =>
	import("@/apps/person-registration/views/StyleView.vue");
const WaitValidationView = () =>
	import("@/apps/person-registration/views/WaitValidationView.vue");

const enableRUMMeta = { enableRUM: true };

const routes: Array<RouteRecordRaw> = [
	{
		path: "/person-registration/style-guide",
		name: RouteName.StyleView,
		component: StyleView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/pr/:registrationTag",

		name: RouteName.PersonRegistration,
		component: PersonRegistrationView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/privacy-policy",
		name: RouteName.PrivacyPolicy,
		component: PrivacyPolicyView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/id-capture",
		name: RouteName.IdentificationUploader,
		component: IdentificationUploaderView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/external-uploader",
		name: RouteName.ExternalUploader,
		component: ExternalUploaderView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/person-contact-info",
		name: RouteName.PersonContactInfo,
		component: PersonContactInfoView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/stepwise-contact-info",
		name: RouteName.StepwiseContactInfo,
		component: StepwiseContactInfoView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/rejected",
		name: RouteName.Rejected,
		component: RejectionView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/correction",
		name: RouteName.Correction,
		component: CorrectionView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/password-creation",
		name: RouteName.PasswordCreation,
		component: PasswordCreationView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/payment-method",
		name: RouteName.PaymentMethod,
		component: PaymentMethodView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/wait-validation",
		name: RouteName.WaitValidation,
		component: WaitValidationView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/id-rejected",
		name: RouteName.IdRejected,
		component: IdRejectedView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/expired",
		name: RouteName.RegistrationExpired,
		component: RegistrationExpiredView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
	{
		path: "/person-registration/:userTag/complete",
		name: RouteName.RegistrationComplete,
		component: RegistrationCompleteView,
		meta: enableRUMMeta,
		beforeEnter: [personRegistrationTranslationGuard],
	},
];

export default routes;
